import dateTime from './dateTime'

const activateFreeTrial = "Start a <span class='primary--text'>free trial</span> today for more features."
const tryOnSubscription = "Try a <span class='primary--text'>subscription</span> and you'll be 😲"
const thankYouForPaying = 'Thank you for your support 🙌'

export default {
  free: 'Free',
  subscription: 'Subscription',
  paidAccess: 'Supporter \\o/',
  accountExpirationSummary: expiration => expiration instanceof Date
    ? `Subscription expires ${dateTime.mmmDdYyyy(expiration)}`
    : '',
  accountPaidStatus: isPaid => `You currently have ${isPaid ? 'subscription' : 'free'} access.`,
  accountPayStatusAction: (isPaid, hasFreeTrial) => {
    if (hasFreeTrial === null) { return '' }
    return isPaid
      ? thankYouForPaying
      : (hasFreeTrial ? activateFreeTrial : tryOnSubscription)
  },
  catchyPricingTitle: 'Create Fantastical Characters',
  currentPricePoints: '$10/mo or $99/yr',
  currentDiscount: 'Promo: 50% off* at $5/mo or $49/yr',
  priceDiscountReversion: '*Promo pricing applies as long as a subscription is continuously renewed at the same rate. Changing or canceling a subscription ends promo pricing.',
  freePoints: [
    'Create and share characters publicly',
    'Characters are accessible for 7 days',
    'Characters are viewable by anyone'
  ],
  paidPoints: [
    'Create and update characters to your private account',
    'Download rigged and animated character assets',
    'Total ownership and unlimited rights of downloaded assets',
    'Share characters with a link',
    'Up to 5GB of Cloud storage'
  ],
  subscribeDialogTitle: hasFreeTrial => hasFreeTrial ? 'Subscription Free Trial' : 'Service Subscription',
  purchaseSubscription: hasFreeTrial => hasFreeTrial
    ? 'Submit your name and email address to start a free trial.'
    : 'If you would like to purchase a subscription Submit your name and email address and we will get in touch.',
  activatingFreeTrial: 'Activating free trial...',
  freeTrialActivated: (started) => {
    return started
      ? 'Your free trial is activated. Enjoy :)'
      : 'There seems to be a problem with starting your free trial. Please try again later.'
  }
}
